import * as React from 'react';
import { InputWrapperInput } from '../../../../../../internal/components/InputWrapperInput/InputWrapperInput';
import styles from './CharInput.module.css';
import { InputWrapper } from '../../../../../../internal/components/InputWrapper';
import { FocusObserver } from '../../../../../../internal/components/FocusObserver/FocusObserver';
import { jsx as _jsx } from "react/jsx-runtime";
export var CharInput = /*#__PURE__*/React.forwardRef(function CharInput(props, ref) {
  var _props$value = props.value,
    value = _props$value === void 0 ? '' : _props$value,
    disabled = props.disabled,
    invalid = props.invalid,
    focused = props.focused,
    focusSource = props.focusSource,
    onClick = props.onClick,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onKeyDown = props.onKeyDown,
    onPaste = props.onPaste;
  var handleFocus = function handleFocus(focused, source) {
    if (focused) {
      onFocus(source);
    } else {
      onBlur();
    }
  };
  return /*#__PURE__*/_jsx(InputWrapper, {
    focused: focused,
    focusSource: focusSource,
    disabled: disabled,
    invalid: invalid,
    size: "M",
    width: 44,
    onClick: onClick,
    onKeyDown: onKeyDown,
    children: /*#__PURE__*/_jsx(FocusObserver, {
      onFocus: handleFocus,
      children: /*#__PURE__*/_jsx(InputWrapperInput, {
        ref: ref,
        type: "tel",
        value: value,
        autoComplete: "off",
        maxLength: 1,
        tabIndex: -1,
        disabled: disabled,
        className: styles['input'],
        "data-mark": "ConfirmationInput|CharInput",
        onChange: function (_onChange) {
          function onChange(_x) {
            return _onChange.apply(this, arguments);
          }
          onChange.toString = function () {
            return _onChange.toString();
          };
          return onChange;
        }(function (e) {
          return onChange(e.currentTarget.value);
        }),
        onPaste: onPaste
      })
    })
  });
});